import React from 'react';
import './Hero.css';

const Hero = () => {
  const handleBookConsultation = () => {
    window.open('https://calendly.com/maitreyeegoswami/discoverycall', '_blank');
  };

  return (
    <section className="hero">
      <div className="hero-rule"></div>
      <h1 className="hero-headline">
        Most leaders know<br />what they want to say.<br />
        <em>Very few know<br />how to make it land.</em>
      </h1>
      <p className="hero-sub">
        We work with founders, CEOs, and CXOs to shape positioning in moments that matter — when clarity, credibility, and trust are non-negotiable.
      </p>
      <div className="hero-actions">
        <button onClick={handleBookConsultation} className="btn-primary">Book a discovery call</button>
        <span className="hero-note">30 minutes. No pitch.</span>
      </div>
    </section>
  );
};

export default Hero;
